class BBAnalyticsService {
  constructor() {
    this.providers = [];
  }

  //   subscribe(bbStorage) {
  //     bbStorage.subscribe(Actions.Routing.Moved, ({ data }) => {
  //       this.triggerPageView(data.name);
  //     });
  //   }

  triggerPageView(page) {
    this.providers.forEach((provider) => {
      provider.providerInstance.pageView(page);
    });
  }

  setProviderData(providerName, providerInstance, providerElements) {
    this.providers.push({
      providerName,
      providerInstance,
      providerElements,
    });
  }

  triggerMultipleEvents(events) {
    events.forEach((event) => {
      this.triggerEventTrack(
        event.eventName, event.trackLabelInfo, event.trackCategoryInfo, event.trackActionInfo,
      );
    });
  }

  triggerEventTrack(eventName, trackLabelInfo, trackCategoryInfo, trackActionInfo) {
    this.providers.forEach((provider) => {
      const opts = {
        bbTrack: eventName,
        bbTrackLabelInfo: trackLabelInfo,
        bbTrackCategoryInfo: trackCategoryInfo,
        bbTrackActionInfo: trackActionInfo,
      };

      const eventAttrs = this.getAttributes(opts, provider.providerElements);

      if (eventAttrs) {
        provider.providerInstance.eventTrack(
          eventAttrs, trackLabelInfo, trackCategoryInfo, trackActionInfo,
        );
      }
    });
  }

  /* eslint-disable class-methods-use-this */
  getAttributes(attrs, providerElements) {
    // e.g 'confirmation.purchases.printButton' -> ['confirmation', 'purchases', 'printButton']
    const path = attrs.bbTrack ? attrs.bbTrack.split('.') : [];


    // If configuration at any level is not defined attributes will be also undefined.
    /* eslint-disable no-shadow */
    const attributes = path.reduce(
      (attributes, key) => (attributes ? attributes[key] : undefined), providerElements,
    );
    /* eslint-enable no-shadow */

    // Get additional info about tracking item.
    if (attributes) {
      attributes.trackLabelInfo = attrs.bbTrackLabelInfo ? attrs.bbTrackLabelInfo : '';
      attributes.trackCategoryInfo = attrs.bbTrackCategoryInfo ? attrs.bbTrackCategoryInfo : '';
      attributes.trackActionInfo = attrs.bbTrackActionInfo ? attrs.bbTrackActionInfo : '';
    }

    return attributes;
  }
  /* eslint-enable class-methods-use-this */
}

export const bbAnalytics = new BBAnalyticsService();
